<app-modal-template
  [title]="'Import Google Slides' | translate"
  [hasCloseButton]="true"
  [size]="PencilModalSizeEnum.MEDIUM"
  (closeButtonClicked)="onCancel()"
>
  <div content-description class="slides-url-dialog__body">
    <label class="slides-url-dialog__label">{{ 'PASTE GOOGLE SLIDES LINK' | translate }}</label>
    <input
      class="slides-url-dialog__input"
      [(ngModel)]="url"
      (ngModelChange)="onUrlChange()"
      placeholder="https://docs.google.com/presentation/d/..."
    />
  </div>
  <div content-actions>
    <app-pencil-button
      [theme]="PencilButtonThemeEnum.SECONDARY_OUTLINE"
      icon="close"
      [iconConfig]="{ type: IconTypes.matIcon }"
      [label]="'Cancel' | translate"
      (clickEvent)="onCancel()"
    >
    </app-pencil-button>
    <app-pencil-button
      [theme]="PencilButtonThemeEnum.PRIMARY"
      icon="check"
      [iconConfig]="{ type: IconTypes.matIcon }"
      [label]="'Import' | translate"
      [disabled]="!isValid"
      (clickEvent)="onImport()"
    >
    </app-pencil-button>
  </div>
</app-modal-template>
